var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getElementStyles(el, property) {
    const elementStyles = window.getComputedStyle(el);
    return elementStyles.getPropertyValue(property);
}
export function eventListenerDebouncer(element, eventType, debouncedFunction, time = 250) {
    let timer;
    element.addEventListener(eventType, (event) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            debouncedFunction(event);
        }, time);
    });
}
export function resizeDebouncer(debouncedFunction, time = 250, ignoreVertical = false) {
    let resizeTimer;
    let screenWidth = window.innerWidth;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (ignoreVertical) {
                const currentWidth = window.innerWidth;
                if (currentWidth - screenWidth !== 0) {
                    debouncedFunction();
                }
                screenWidth = currentWidth;
            }
            else {
                debouncedFunction();
            }
        }, time);
    });
}
export function checkDevice() {
    try {
        const deviceAgent = navigator.userAgent.toLowerCase();
        const htmlElement = document.querySelector("html");
        if (!htmlElement)
            return;
        if ("ontouchstart" in globalThis &&
            window.screen.width * window.devicePixelRatio >= 2048 &&
            window.screen.width < window.screen.height) {
            htmlElement.classList.add("highResTabletPortrait");
        }
        if ("ontouchstart" in globalThis) {
            htmlElement.classList.add("touch");
        }
        if (navigator.connection) {
            htmlElement.classList.add(navigator.connection.effectiveType);
        }
        if (navigator.platform) {
            let platform = navigator.platform.toLowerCase();
            let platformArray = [platform];
            if (platform.search("-")) {
                platformArray = platform.split("-");
            }
            if (platform.search(" ")) {
                platformArray = platform.split(" ");
            }
            htmlElement.classList.add(...platformArray);
        }
        if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
            htmlElement.classList.add("ios");
            htmlElement.classList.add("mobile");
        }
        if (deviceAgent.match(/(windows)/)) {
            htmlElement.classList.add("windows");
        }
        if (deviceAgent.match(/(macintosh)/)) {
            htmlElement.classList.add("mac");
        }
        if (deviceAgent.match(/(android)/)) {
            htmlElement.classList.add("android");
        }
        if (navigator.userAgent.search("MSIE") >= 0) {
            htmlElement.classList.add("ie");
        }
        else if (navigator.userAgent.search("Edge") >= 0) {
            htmlElement.classList.add("edge-legacy");
        }
        else if (navigator.userAgent.search("Chrome") >= 0) {
            htmlElement.classList.add("chrome");
        }
        else if (navigator.userAgent.search("Firefox") >= 0) {
            htmlElement.classList.add("firefox");
        }
        else if (navigator.userAgent.search("Safari") >= 0 &&
            navigator.userAgent.search("Chrome") < 0) {
            htmlElement.classList.add("safari");
        }
        else if (navigator.userAgent.search("Opera") >= 0) {
            htmlElement.classList.add("opera");
        }
    }
    catch (error) {
        console.error(error);
    }
}
function pushData(time) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ttfb: time });
}
export function ttfb() {
    new PerformanceObserver((entryList) => {
        const [pageNav] = entryList.getEntriesByType("navigation");
        const time = pageNav.responseStart;
        pushData(time);
    }).observe({ type: "navigation", buffered: true });
}
export function isWpAdmin() {
    return document.body.classList.contains("wp-admin");
}
function loadScript(src) {
    return __awaiter(this, void 0, void 0, function* () {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
        yield new Promise((resolve, reject) => {
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Script load error for ${src}`));
        });
    });
}
function handleCTBClick(event) {
    return __awaiter(this, void 0, void 0, function* () {
        event.preventDefault();
        if (!window.isCTBLoaded) {
            yield loadScript(`/wp-content/plugins/pr-clicktobuy/public/js/pr-clicktobuy-public.js`);
            window.isCTBLoaded = true;
            const clonedEvent = new event.constructor(event.type, event);
            setTimeout(() => {
                event.target.dispatchEvent(clonedEvent);
            }, 500);
        }
    });
}
function setAttributesToMenuItem(element) {
    const body = document.querySelector("body");
    const localLang = body.dataset.sitelanguage;
    const locale = localLang.replace(/_/g, "-");
    element.setAttribute("data-ctbuy-lang", locale);
}
export function ctbCTAClickHandler(block = document) {
    const elements = block.querySelectorAll("[data-ctbuy]");
    elements.forEach((element) => {
        setAttributesToMenuItem(element);
        element.addEventListener("click", handleCTBClick);
    });
}
export function adjustZoomMultiplier(initialPixelRatio) {
    const modifier = initialPixelRatio === 2 ? 1 : 0;
    const multiplier = window.devicePixelRatio - modifier;
    const screenWidthVar = parseFloat(getElementStyles(document.body, "--screen-width"));
    const root = document.documentElement;
    const val = (screenWidthVar * multiplier).toString();
    root.style.setProperty("--font-reference", val + "vw");
}
/**
 * This listener returns the device screen height on scroll to show when the screen height has changed due to the expanding ios navigation bar.
 * @param {object} options Options object where you can remove the listener by setting remove to true.
 * @returns {number} The available screen height for content.
 */
export function screenHeightDetectOnScroll(options = { remove: false }) {
    try {
        const returnAvailableScreenHeight = () => {
            return window.innerHeight;
        };
        if (options.remove === true) {
            window.removeEventListener("scroll", returnAvailableScreenHeight);
            return;
        }
        eventListenerDebouncer(window, "scroll", returnAvailableScreenHeight);
    }
    catch (error) {
        console.log(error);
    }
}
/**
 * Function for adding a link tag with preconnect to the head of the document. Very useful if you need to add this dynamically.
 * @param {string} domain The domain you wish to preconnect to.
 * @returns {void} The preconnect will be appended to the head tag.
 */
export function appendPreconnect(domain) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = domain;
    document.head.appendChild(link);
    return;
}
/**
 * Dynamically retrieves the swiper css and js and returns a resolved promise when they have both been successfully fetched.
 * @returns {promise}
 */
export function getSwiperAssetsV2(options = {}) {
    const getSwiperJs = () => import(
    /* webpackChunkName: 'swiper' */ "NodeModules/swiper/swiper-bundle.js");
    // const getSwiperCss = () =>
    // 	import(
    // 		/* webpackChunkName: 'swipercss'  */
    // 		'NodeModules/swiper/swiper/css'
    // 	);
    const promisedJs = Promise.all([getSwiperJs()]).then((values) => {
        return values;
    });
    return promisedJs;
}
/**
 * Detects swipe actions on a element and runs a callback function.
 *
 * @param {htmlElement} element The element on which you want to detect swipe actions.
 * @param {function} callback The callback function to run when a swipe is detected.
 * @returns {void} Attaches or removes the functionality.
 */
export function detectSwipe(element, callback, removeHandlers = "") {
    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;
    function handleGesture(touchstartX, touchstartY, touchendX, touchendY, pixels = 50) {
        const delx = touchendX - touchstartX;
        const dely = touchendY - touchstartY;
        if (Math.abs(delx) > pixels || Math.abs(dely) > pixels) {
            if (Math.abs(delx) > Math.abs(dely)) {
                if (delx > 0)
                    return "right";
                else
                    return "left";
            }
            else if (Math.abs(delx) < Math.abs(dely)) {
                if (dely > 0)
                    return "down";
                else
                    return "up";
            }
        }
        else
            return "tap";
    }
    function touchStart(event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
    }
    element.addEventListener("touchstart", () => touchStart(event), false);
    element.addEventListener("touchend", function (event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        callback(handleGesture(touchstartX, touchstartY, touchendX, touchendY));
    }, false);
    if (removeHandlers === "remove") {
        element.removeEventListener("touchstart", touchStart);
        element.removeEventListener("touchend", handleGesture);
        return;
    }
}
/**
 * Converts vertical scroll action into horizontal scroll action.
 *
 * @param {htmlElement} element The element on which you want to invert the scroll action.
 * @param {string} remove Optional argument to remove the scrolljacking functionality. Pass 'remove' as the value.
 * @returns {void} Attaches or removes the functionality.
 */
export function scrollJack(element, remove = "") {
    function scrollHandler(event) {
        if (event.deltaY > 0 || event.deltaY < 0) {
            event.preventDefault();
            element.scrollBy({
                left: event.deltaY < 0 ? -80 : 80,
            });
        }
    }
    if (remove === "remove") {
        element.removeEventListener("wheel", scrollHandler);
        return;
    }
    element.addEventListener("wheel", scrollHandler);
}
/**
 * Adds or removes click/drag functionality to a scrollable container.
 *
 * @param {htmlElement} scrollContainer The scrollable element to add the drag functionality to.
 * @param {string} removeHandlers An optional parameter to remove the functionality. To remove click drag pass 'remove' as the value for this parameter.
 * @returns {void} Attaches or removes the functionality.
 */
export function clickDrag(scrollContainer, removeHandlers = "") {
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    const mouseMoveHandler = (e) => {
        scrollContainer.classList.add("grabbing");
        const dx = e.clientX - pos.x;
        scrollContainer.scrollLeft = pos.left - dx;
    };
    const mouseUpHandler = () => {
        scrollContainer.removeEventListener("mousemove", mouseMoveHandler);
        scrollContainer.classList.remove("grabbing");
    };
    const mouseDownHandler = (event) => {
        event.preventDefault();
        scrollContainer.addEventListener("mouseup", mouseUpHandler, {
            once: true,
        });
        pos = {
            // The current scroll
            left: scrollContainer.scrollLeft,
            top: scrollContainer.scrollTop,
            // Get the current mouse position
            x: event.clientX,
            y: event.clientY,
        };
        scrollContainer.classList.add("grabbing");
        scrollContainer.addEventListener("mousemove", mouseMoveHandler);
    };
    if (removeHandlers === "remove") {
        scrollContainer.removeEventListener("mousemove", mouseMoveHandler);
        scrollContainer.removeEventListener("mouseup", mouseUpHandler);
        scrollContainer.removeEventListener("mousedown", mouseDownHandler);
        return;
    }
    scrollContainer.addEventListener("mousedown", mouseDownHandler);
}
/**
 * Get a rounded percentage value using two numbers.
 *
 * @param {number} total The value you want get a percentage of.
 * @param {number} part The value that is a fraction of the total.
 * @returns {number} The rounded percentage value.
 */
export function getPercent(total, part) {
    return Math.round((part / total) * 100);
}
// by default connection is good, this function checks connection and if the speed is bad -  changes the lowConnection variable to true
export function detectBadConnection(src, bytes, timeLimit = 3, speed = 2) {
    console.log("detect");
    let time_start = new Date().getTime();
    let userImageLink = src + "?t=" + time_start;
    let downloadImg = new Image();
    let imageDownloaded = false;
    let lowConnection = false;
    downloadImg.onload = function () {
        let end_time = new Date().getTime();
        let timeDuration = (end_time - time_start) / 1000;
        let bits = bytes * 8;
        let bps = bits / timeDuration;
        let speedInMbps = Number((bps / 1024 / 1024).toFixed(2));
        imageDownloaded = true;
        if (speedInMbps < speed) {
            lowConnection = true;
        }
    };
    downloadImg.src = userImageLink;
    // timeLimit in case onLoad event will not happen in 3 sec, otherwise it will wait for image to load even if it's 30 seconds
    setTimeout(function () {
        if (!imageDownloaded) {
            downloadImg.onload = null;
            lowConnection = true;
        }
    }, timeLimit * 1000);
    return lowConnection;
}
export function xmlToJson(xml) {
    // Create the return object
    let obj = {};
    if (xml.nodeType == 1) {
        // element
        // do attributes
        if (xml.attributes.length > 0) {
            obj['@attributes'] = {};
            for (let j = 0; j < xml.attributes.length; j++) {
                let attribute = xml.attributes.item(j);
                obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
        }
    }
    else if (xml.nodeType == 3) {
        // text
        obj = xml.nodeValue;
    }
    // do children
    if (xml.hasChildNodes()) {
        for (let i = 0; i < xml.childNodes.length; i++) {
            let item = xml.childNodes.item(i);
            let nodeName = item.nodeName;
            if (typeof obj[nodeName] == 'undefined') {
                obj[nodeName] = xmlToJson(item);
            }
            else {
                if (typeof obj[nodeName].push == 'undefined') {
                    let old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(xmlToJson(item));
            }
        }
    }
    return obj;
}
